// extracted by mini-css-extract-plugin
export default {"MessagesContainer":"_MessagesContainer--RQvxa","ExtraMargin":"_ExtraMargin--xtZLv","ScrollArea":"_ScrollArea--TJbhh","Banner":"_Banner--OuRGD"};